import script from "./TenantSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantSideBar.vue?vue&type=script&setup=true&lang=js"

import "./TenantSideBar.vue?vue&type=style&index=0&id=16cc7cf7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16cc7cf7"]])

export default __exports__